<form class="w-100 p-0">
    <mat-form-field class="w-100" appearance="outline">
        <input
            type="text"
            placeholder="{{ getSelectedItems() }}"
            aria-label="Number"
            matInput
            [matAutocomplete]="auto"
        />
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
            <mat-checkbox
                class="checklist-leaf-node"
                [checked]="isAllSelected()"
                (change)="selectAllItems($event)"
            >
                Select All
            </mat-checkbox>
            <mat-option disabled> Please select an item from below </mat-option>
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                <mat-tree-node
                    *matTreeNodeDef="let node"
                    matTreeNodeToggle
                    matTreeNodePadding
                >
                    <button mat-icon-button disabled></button>
                    <mat-checkbox
                        class="checklist-leaf-node"
                        [checked]="checklistSelection.isSelected(node)"
                        (change)="todoLeafItemSelectionToggle(node)"
                    >
                        {{ node.item }}
                    </mat-checkbox>
                </mat-tree-node>

                <mat-tree-node
                    *matTreeNodeDef="let node; when: hasChild"
                    matTreeNodePadding
                >
                    <button
                        mat-icon-button
                        matTreeNodeToggle
                        [attr.aria-label]="'toggle ' + node.filename"
                    >
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{
                                treeControl.isExpanded(node)
                                    ? "expand_more"
                                    : "chevron_right"
                            }}
                        </mat-icon>
                    </button>
                    <mat-checkbox
                        [checked]="descendantsAllSelected(node)"
                        [indeterminate]="descendantsPartiallySelected(node)"
                        (change)="todoItemSelectionToggle(node)"
                    >
                        {{ node.item }}
                    </mat-checkbox>
                </mat-tree-node>
            </mat-tree>
        </mat-autocomplete>
    </mat-form-field>
</form>
